import { colorSchema } from './../../core/services/interface';
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Lightbox } from "ngx-lightbox/lightbox.service";
import {
  c1,
  c12,
  c3,
  c4,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";
import { CorePalette, TonalPalette, argbFromHex, hexFromArgb } from "@material/material-color-utilities";


@Component({
  selector: "app-gen-anavtab-component",
  templateUrl: "./gen-anavtab-component.component.html",
  styleUrls: ["./gen-anavtab-component.component.scss"],
})
export class GenAnavTabComponentComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService,
    private lightbox: Lightbox
  ) {}

  @Input() page_id: string;
  @Input() tabData: Tab;

  page: any;
  c4_value: string;
  c5_value: string;
  c3_value: string;
  offCanvasSubscription: any;
  colorsComponentSubscription: any;
  albums = [];
  title: string;
  offcanvasColors = offcanvasColors;
  enableNav: boolean;
  singleTab: string = c3.SINGLE;
  mode: string;
  colors: any;
  isLight: boolean;
  data: any;
  isAndroid: boolean;
  newColors: colorSchema;
  appHome: any;

  ngOnInit() {
    this.albums = [
      {
        id: c4.TOP,
        src: "../../../assets/images/small/img-1-anavtab.jpg",
        caption: " Tab Navigation",
      },
      {
        id: c4.BOTTOM,
        src: "../../../assets/images/small/img-2-anavtab.jpg",
        caption: " Bottom Bar",
      },
    ];

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "gen" &&
          data.page.id == this.page_id
        ) {
          this.c3_value = localStorage.getItem("mode")[2];
          this.c4_value = localStorage.getItem("mode")[3];
          this.changeTitle();
        }
      }
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
          this.colors = data;
          this.isLight = data.light;
        }
      });
  }

  open(index: number): void {
    // open lightbox
    this.c4_value = this.albums[index].id;
    let modes = [{ id: c4.ID, value: this.c4_value }];
    this.mdw.changeMobileTheme(modes);
    this.changeTitle();
    this.mdw.changeTab(
      { tab: this.tabData },
      localStorage.getItem("mode"),
      true
    );
    this.updateColors()
  }

updateColors() {
  if (this.colors) {

    let newColors: colorSchema;
     newColors = this.builderService.updateExtraMaterialColor(this.colors.color_schema, c1.ANDROID );

    this.colors.color_schema = newColors;
    this.mdw._colorsComponentContainer.next(this.colors);
    this.updateAppAndroid(this.colors.color_schema);
  }
}



updateAppAndroid(newColors) {
  if (this.colors && this.colors.color_schema && this.colors.color_schema_ios) {
    const appHome = this.indexDBService.getItem("app", "home");
    if (appHome) {
      appHome.onsuccess = (event) => {
        if (appHome.result) {
          this.appHome = appHome.result;

          // Store ONLY simple, clean HEX-based colors:
          this.appHome["app"]["tabs"]["color_schema"] = {
            schemes: newColors.schemes,
            style: newColors.style,
            source: newColors.source,
            palettes: this.colors.color_schema.palettes // Original simple palette
          };

          this.indexDBService.updateItem("app", this.appHome);
        }
      };
    }
  }
}

  changeTitle() {
    if (this.c3_value === c3.SINGLE) {
      this.title = "Single Page";
    } else if (this.c4_value == c4.TOP) {
      this.title = "Tabs";
    } else {
      this.title = "Bottom Navigation";
    }
  }
  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }
}


function reconstructPalettesFromStoredData(storedColors: any) {
  const palettes: { [key: string]: TonalPalette } = {};

  for (const key of Object.keys(storedColors.palettes)) {
    // Try multiple methods to obtain hex
    let paletteHex =
      storedColors.palettes[key]?.keyColor?.id ||
      storedColors.palettes[key]?.keyColor;

    if (!paletteHex || typeof paletteHex !== 'string') {
      console.warn(`Invalid hex for palette '${key}', stored value:`, storedColors.palettes[key]);
      paletteHex = "#000000"; // fallback default HEX
    }

    const corePalette = CorePalette.of(argbFromHex(paletteHex));

    switch (key) {
      case 'primary':
        palettes[key] = corePalette.a1;
        break;
      case 'secondary':
        palettes[key] = corePalette.a2;
        break;
      case 'tertiary':
        palettes[key] = corePalette.a3;
        break;
      case 'error':
        palettes[key] = corePalette.error;
        break;
      case 'neutral':
        palettes[key] = corePalette.n1;
        break;
      case 'neutralVariant':
        palettes[key] = corePalette.n2;
        break;
      default:
        palettes[key] = corePalette.a1;
    }
  }

  return palettes;
}
